"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.replace");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _auth = require("../../utils/auth");

var _button_widget = _interopRequireDefault(require("@/views/widgets/button_widget.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    ButtonWidget: _button_widget.default
  },
  data: function data() {
    return {
      services: [{
        id: 0,
        title: '製品の新規・追加購入、またはアップグレードに関するお問い合わせ'
      }, {
        id: 1,
        title: '支払い方法 ・請求・解約に関するお問い合わせ'
      }, {
        id: 2,
        title: '製品の機能・操作に関するリソース'
      }, {
        id: 3,
        title: 'テクニカルサポートへのお問い合わせ'
      }, {
        id: 4,
        title: 'マーケティングに関するお問い合わせ'
      }]
    };
  },
  computed: {
    myUser: function myUser() {
      return this.$store.getters.myUser;
    },
    role: {
      get: function get() {
        return JSON.parse((0, _auth.getUserPermission)());
      }
    }
  },
  created: function created() {},
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    goToDetailUser: function goToDetailUser() {
      (0, _auth.setGoFromPage)('Profile');
      this.$router.replace({
        name: 'CompanyAdminEdit',
        params: {
          uid: (0, _auth.getUserUID)()
        }
      });
    },
    goToDetailPermission: function goToDetailPermission() {
      (0, _auth.setGoFromPage)('Profile');
      this.$router.replace({
        name: 'RoleIndex'
      });
    }
  }
};
exports.default = _default;